// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity_activityPostCard__pB-mc {
  display: flex;
  flex-direction: column;
  /* justify-content: center;
      align-items: center; */
  margin: 10px;
  padding: 10px 10px 7px 10px;
  /* overflow-x: auto; */
  border-width: 0px;
  border-radius: 20px;
  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */
  background-color: rgba(249, 249, 248, 0.9);
  width: 100%;
}

@media screen and (min-width: 768px) {
  .activity_activityPostCard__pB-mc {
    width: 340px;
  }
}

@media screen and (min-width: 1024px) {
  .activity_activityPostCard__pB-mc {
    width: 420px;
  }
}
.activity_activityPostDescriptionContainer__V5zMX {
  margin-top: 3px;
  overflow-wrap: break-word;
}
.activity_activityPostDescriptionContainer__V5zMX p {
  margin: 0;
  margin-top: 3px;
  /* margin-bottom: 5px; */
}
.activity_locationContent__g0agd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 142px;
  display: inline-block;
  vertical-align: middle;
}
.activity_timeLocationContainer__KEmkL {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 10px;
}
.activity_locationContainer__9HQTK {
  display: flex;
  align-items: center;
  gap: 2px;
}
.activity_tenantAndTimeName__T3OiT {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 142px;
  display: inline-block;
  vertical-align: middle;
}
.activity_tenantAndTimeNameWithoutLocation__-76vg {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  display: inline-block;
  vertical-align: middle;
}
.activity_locationIconImg__geqiP {
  height: 12px;
  margin-right: 3px;
}
.activity_blockOrwarnMessage__Pbmka {
  font-size: 15px;
  color: #373334;
}
.activity_blockOrwarnMessageReason__e9jk2{
  font-size: 15px;
  color: #373334;
}
.activity_dotImg__Tw4ao {
  margin: 0px 2px 0px -2px;
}
.activity_messageContent__OYeWr {
  /* overflow: hidden; */
  text-overflow: ellipsis;
  white-space: wrap;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
}
.activity_activityPostProfileIg__rzytG {
  /* border-radius: 10px;
  width: 40px;
  height: 45px; */

  /* margin-right: 10px; */
  border-radius: 40% !important;
  width: 50px !important;
  height: 50px !important;
}
.activity_activityPostImageDropdownMainContainer__ej8YP {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.activity_activityPostImageProfileContainer__bDawd {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.activity_activityPostCardImagePopupMainContainer__ifvii {
  display: flex;
  flex-direction: column;
}
.activity_activityPostCardPopup__mkdfW {
  /* position: absolute; */
  /* top: 100%;
  left: 0; */
  width: max-content;
  z-index: 2;
  background: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 8px;
}
.activity_activityPostCardDropdownImg__8dIBN {
  height: 5px;
  width: 10px;

  margin-right: 10px;
}
.activity_activityPostCardDropdownButton__879GX {
  border-width: 0px;
  background-color: transparent;
  align-self: flex-end;
  margin-bottom: -10px;
  padding-right: 10px;
}
.activity_activityPostCardDropdownButton__879GX:focus {
  outline: 0px solid #007bff;
}
.activity_activityPostCardDropdownIcon__WHDbZ {
  font-size: 20px;
  color: #373334;
  margin-left: auto;
}
.activity_activtyPostEditDeleteButton__1lbiC {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
.activity_activtyPostEditDeleteButton__1lbiC p {
  color: #373334;
}
.activity_likeCountContainer__NXsSN {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.activity_likeCountContainerButton__qF40f {
  border-width: 0px;
  background-color: transparent;
  cursor: pointer;
  color: #007bff;
  margin-top: -1px;
  outline: none !important;
}
.activity_dotIcon__ec0Tw {
  margin-top: 2px;
  font-size: 15px;
  margin-right: -6px;
}
.activity_sayPostPopup__Xd42D {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #ffffff;
  border-width: 0px;
  border-radius: 10px;
  padding: 10px;
  z-index: 900;
  position: relative;
}
.activity_sayPostPopupImage__lyHxY {
  height: 35px;
  width: 32px;
  border-radius: 10px;
  margin-right: 8px;
}
.activity_sayPostImageContainer__KxBje {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.activity_sayPostPopupName__B9\\+kE {
  font-weight: 500;
  font-size: 14px;
  color: #373334;
  margin-bottom: -2px;
}
.activity_activityPostButtonContainer__aQwye {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  border: none;
  background: transparent;
  outline: none !important;
  margin-top: 4px;
}
.activity_activityPostButtonContainer__aQwye img {
  height: 20px;
  margin-right: 6px;
}
.activity_activityPostButtonContainer__aQwye p {
  margin-top: -2px;
}
.activity_askTagPopupNameTimeMainContainer__zgv0N {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.activity_askTagPopupNameTimeContainer__BOHDq {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 15px;
  margin-bottom: 15px;
}
.activity_askTagPopupNameTimeContainer__BOHDq span {
  margin-top: -15px;
  font-size: 15px;
}
.activity_askTagPopupDropdownButton__deNEk {
  border-width: 0px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  margin-bottom: auto;
  outline: none !important;
  margin-left: auto;
}
.activity_askTagPopupFollowers__T1ED\\+ {
  margin-top: 20px;
  color: #373334;
  font-size: 12px;
  margin-bottom: -12px;
  cursor: pointer;
}
.activity_askTagPopupHorizontalLine__8W1Y- {
  border: 1px solid #37333461;
  margin-top: 3px;
}
.activity_profilename__3O5NU {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  position: relative;
}
.activity_profilename__3O5NU:hover .activity_profilehover__j9AIA,
.activity_profileimg__\\+HMCo:hover + div .activity_profilehover__j9AIA {
  display: block;
  font-size: 12px;
  font-weight: 400;
}
.activity_profilehover__j9AIA {
  display: none;
  position: absolute;
  top: 110%;
  left: -50px;
  background-color: white;
  min-width: 320px;
  z-index: 2;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 15px;
  padding: 15px;
}
.activity_profilehoverimageandcount__zABpn {
  display: flex;
}
.activity_profilecount__dChuV {
  margin-bottom: 0px !important;
  font-size: 12px !important;
  color: #878585 !important;
  font-weight: 400 !important;
}
.activity_profilehovername__p5\\+SE {
  margin-bottom: 0px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}
.activity_profilehovercontent__GSgkC {
  font-weight: 400 !important;
  font-size: 12px !important;
  margin-top: 1rem !important;
  margin-bottom: 0 !important;
}
.activity_activityPostWarning__zEfN6 {
  color: red;
  margin-top: 4px;
  margin-bottom: 1px;
}
.activity_activityAskPostButtonContainer__5CdTj {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.activity_activityAskPostButton__4-N2H {
  padding: 5px 20px;
  border-width: 0px;
  border-radius: 18px;
  background-color: #2168b2;
  color: #ffffff;
  cursor: pointer;
  font-size: 15px;
}
.activity_activityAnswerIcon__EhnYF {
  height: 28px;
  margin-right: -2px;
}
.activity_activityReplyIcon__ep4cC {
  height: 18px;
  margin-right: 6px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/Activity/activity.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB;4BAC0B;EAC1B,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE;;iBAEe;;EAEf,wBAAwB;EACxB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB;YACU;EACV,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;;EAEX,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,+CAA+C;EAC/C,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B","sourcesContent":[".activityPostCard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* justify-content: center;\r\n      align-items: center; */\r\n  margin: 10px;\r\n  padding: 10px 10px 7px 10px;\r\n  /* overflow-x: auto; */\r\n  border-width: 0px;\r\n  border-radius: 20px;\r\n  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */\r\n  background-color: rgba(249, 249, 248, 0.9);\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .activityPostCard {\r\n    width: 340px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .activityPostCard {\r\n    width: 420px;\r\n  }\r\n}\r\n.activityPostDescriptionContainer {\r\n  margin-top: 3px;\r\n  overflow-wrap: break-word;\r\n}\r\n.activityPostDescriptionContainer p {\r\n  margin: 0;\r\n  margin-top: 3px;\r\n  /* margin-bottom: 5px; */\r\n}\r\n.locationContent {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 142px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.timeLocationContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  margin-left: 10px;\r\n}\r\n.locationContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n.tenantAndTimeName {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 142px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.tenantAndTimeNameWithoutLocation {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 300px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.locationIconImg {\r\n  height: 12px;\r\n  margin-right: 3px;\r\n}\r\n.blockOrwarnMessage {\r\n  font-size: 15px;\r\n  color: #373334;\r\n}\r\n.blockOrwarnMessageReason{\r\n  font-size: 15px;\r\n  color: #373334;\r\n}\r\n.dotImg {\r\n  margin: 0px 2px 0px -2px;\r\n}\r\n.messageContent {\r\n  /* overflow: hidden; */\r\n  text-overflow: ellipsis;\r\n  white-space: wrap;\r\n  max-width: 100%;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.activityPostProfileIg {\r\n  /* border-radius: 10px;\r\n  width: 40px;\r\n  height: 45px; */\r\n\r\n  /* margin-right: 10px; */\r\n  border-radius: 40% !important;\r\n  width: 50px !important;\r\n  height: 50px !important;\r\n}\r\n.activityPostImageDropdownMainContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n}\r\n.activityPostImageProfileContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n.activityPostCardImagePopupMainContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.activityPostCardPopup {\r\n  /* position: absolute; */\r\n  /* top: 100%;\r\n  left: 0; */\r\n  width: max-content;\r\n  z-index: 2;\r\n  background: white;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n}\r\n.activityPostCardDropdownImg {\r\n  height: 5px;\r\n  width: 10px;\r\n\r\n  margin-right: 10px;\r\n}\r\n.activityPostCardDropdownButton {\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  align-self: flex-end;\r\n  margin-bottom: -10px;\r\n  padding-right: 10px;\r\n}\r\n.activityPostCardDropdownButton:focus {\r\n  outline: 0px solid #007bff;\r\n}\r\n.activityPostCardDropdownIcon {\r\n  font-size: 20px;\r\n  color: #373334;\r\n  margin-left: auto;\r\n}\r\n.activtyPostEditDeleteButton {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  border: none;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n}\r\n.activtyPostEditDeleteButton p {\r\n  color: #373334;\r\n}\r\n.likeCountContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n.likeCountContainerButton {\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  color: #007bff;\r\n  margin-top: -1px;\r\n  outline: none !important;\r\n}\r\n.dotIcon {\r\n  margin-top: 2px;\r\n  font-size: 15px;\r\n  margin-right: -6px;\r\n}\r\n.sayPostPopup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  background-color: #ffffff;\r\n  border-width: 0px;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  z-index: 900;\r\n  position: relative;\r\n}\r\n.sayPostPopupImage {\r\n  height: 35px;\r\n  width: 32px;\r\n  border-radius: 10px;\r\n  margin-right: 8px;\r\n}\r\n.sayPostImageContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n.sayPostPopupName {\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: #373334;\r\n  margin-bottom: -2px;\r\n}\r\n.activityPostButtonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  border: none;\r\n  background: transparent;\r\n  outline: none !important;\r\n  margin-top: 4px;\r\n}\r\n.activityPostButtonContainer img {\r\n  height: 20px;\r\n  margin-right: 6px;\r\n}\r\n.activityPostButtonContainer p {\r\n  margin-top: -2px;\r\n}\r\n.askTagPopupNameTimeMainContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n.askTagPopupNameTimeContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  margin-left: 15px;\r\n  margin-bottom: 15px;\r\n}\r\n.askTagPopupNameTimeContainer span {\r\n  margin-top: -15px;\r\n  font-size: 15px;\r\n}\r\n.askTagPopupDropdownButton {\r\n  border-width: 0px;\r\n  display: flex;\r\n  flex-direction: row-reverse;\r\n  justify-content: flex-end;\r\n  margin-bottom: auto;\r\n  outline: none !important;\r\n  margin-left: auto;\r\n}\r\n.askTagPopupFollowers {\r\n  margin-top: 20px;\r\n  color: #373334;\r\n  font-size: 12px;\r\n  margin-bottom: -12px;\r\n  cursor: pointer;\r\n}\r\n.askTagPopupHorizontalLine {\r\n  border: 1px solid #37333461;\r\n  margin-top: 3px;\r\n}\r\n.profilename {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #333;\r\n  position: relative;\r\n}\r\n.profilename:hover .profilehover,\r\n.profileimg:hover + div .profilehover {\r\n  display: block;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n}\r\n.profilehover {\r\n  display: none;\r\n  position: absolute;\r\n  top: 110%;\r\n  left: -50px;\r\n  background-color: white;\r\n  min-width: 320px;\r\n  z-index: 2;\r\n  background: #ffffff 0% 0% no-repeat padding-box;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  border-radius: 15px;\r\n  padding: 15px;\r\n}\r\n.profilehoverimageandcount {\r\n  display: flex;\r\n}\r\n.profilecount {\r\n  margin-bottom: 0px !important;\r\n  font-size: 12px !important;\r\n  color: #878585 !important;\r\n  font-weight: 400 !important;\r\n}\r\n.profilehovername {\r\n  margin-bottom: 0px !important;\r\n  font-size: 14px !important;\r\n  font-weight: 700 !important;\r\n}\r\n.profilehovercontent {\r\n  font-weight: 400 !important;\r\n  font-size: 12px !important;\r\n  margin-top: 1rem !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n.activityPostWarning {\r\n  color: red;\r\n  margin-top: 4px;\r\n  margin-bottom: 1px;\r\n}\r\n.activityAskPostButtonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n}\r\n.activityAskPostButton {\r\n  padding: 5px 20px;\r\n  border-width: 0px;\r\n  border-radius: 18px;\r\n  background-color: #2168b2;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n.activityAnswerIcon {\r\n  height: 28px;\r\n  margin-right: -2px;\r\n}\r\n.activityReplyIcon {\r\n  height: 18px;\r\n  margin-right: 6px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityPostCard": `activity_activityPostCard__pB-mc`,
	"activityPostDescriptionContainer": `activity_activityPostDescriptionContainer__V5zMX`,
	"locationContent": `activity_locationContent__g0agd`,
	"timeLocationContainer": `activity_timeLocationContainer__KEmkL`,
	"locationContainer": `activity_locationContainer__9HQTK`,
	"tenantAndTimeName": `activity_tenantAndTimeName__T3OiT`,
	"tenantAndTimeNameWithoutLocation": `activity_tenantAndTimeNameWithoutLocation__-76vg`,
	"locationIconImg": `activity_locationIconImg__geqiP`,
	"blockOrwarnMessage": `activity_blockOrwarnMessage__Pbmka`,
	"blockOrwarnMessageReason": `activity_blockOrwarnMessageReason__e9jk2`,
	"dotImg": `activity_dotImg__Tw4ao`,
	"messageContent": `activity_messageContent__OYeWr`,
	"activityPostProfileIg": `activity_activityPostProfileIg__rzytG`,
	"activityPostImageDropdownMainContainer": `activity_activityPostImageDropdownMainContainer__ej8YP`,
	"activityPostImageProfileContainer": `activity_activityPostImageProfileContainer__bDawd`,
	"activityPostCardImagePopupMainContainer": `activity_activityPostCardImagePopupMainContainer__ifvii`,
	"activityPostCardPopup": `activity_activityPostCardPopup__mkdfW`,
	"activityPostCardDropdownImg": `activity_activityPostCardDropdownImg__8dIBN`,
	"activityPostCardDropdownButton": `activity_activityPostCardDropdownButton__879GX`,
	"activityPostCardDropdownIcon": `activity_activityPostCardDropdownIcon__WHDbZ`,
	"activtyPostEditDeleteButton": `activity_activtyPostEditDeleteButton__1lbiC`,
	"likeCountContainer": `activity_likeCountContainer__NXsSN`,
	"likeCountContainerButton": `activity_likeCountContainerButton__qF40f`,
	"dotIcon": `activity_dotIcon__ec0Tw`,
	"sayPostPopup": `activity_sayPostPopup__Xd42D`,
	"sayPostPopupImage": `activity_sayPostPopupImage__lyHxY`,
	"sayPostImageContainer": `activity_sayPostImageContainer__KxBje`,
	"sayPostPopupName": `activity_sayPostPopupName__B9+kE`,
	"activityPostButtonContainer": `activity_activityPostButtonContainer__aQwye`,
	"askTagPopupNameTimeMainContainer": `activity_askTagPopupNameTimeMainContainer__zgv0N`,
	"askTagPopupNameTimeContainer": `activity_askTagPopupNameTimeContainer__BOHDq`,
	"askTagPopupDropdownButton": `activity_askTagPopupDropdownButton__deNEk`,
	"askTagPopupFollowers": `activity_askTagPopupFollowers__T1ED+`,
	"askTagPopupHorizontalLine": `activity_askTagPopupHorizontalLine__8W1Y-`,
	"profilename": `activity_profilename__3O5NU`,
	"profilehover": `activity_profilehover__j9AIA`,
	"profileimg": `activity_profileimg__+HMCo`,
	"profilehoverimageandcount": `activity_profilehoverimageandcount__zABpn`,
	"profilecount": `activity_profilecount__dChuV`,
	"profilehovername": `activity_profilehovername__p5+SE`,
	"profilehovercontent": `activity_profilehovercontent__GSgkC`,
	"activityPostWarning": `activity_activityPostWarning__zEfN6`,
	"activityAskPostButtonContainer": `activity_activityAskPostButtonContainer__5CdTj`,
	"activityAskPostButton": `activity_activityAskPostButton__4-N2H`,
	"activityAnswerIcon": `activity_activityAnswerIcon__EhnYF`,
	"activityReplyIcon": `activity_activityReplyIcon__ep4cC`
};
export default ___CSS_LOADER_EXPORT___;
